import { gsap } from "gsap";
import { scrollTo } from "./ScrollLenis";

export default class cursorsAnimations {
    constructor(cursorElement) {
        this.cursor = cursorElement;
        this.group1 = this.cursor.querySelector('.group-1');
        this.group2 = this.cursor.querySelector('.group-2');

        this.options = {
            blinkDuration: parseFloat(this.cursor.dataset.blinkSpeed) || 1,
            swapDuration: parseFloat(this.cursor.dataset.swapSpeed) || 1,
        };

        if (this.group1 && this.group2) {
            this.init();
        }
    }

    init() {
        this.cacheInitialPositions();
        this.setInitialState();
        this.animate();
        this.setupClickScroll();
    }

    cacheInitialPositions() {
        const pos1 = this.group1.getBBox();
        const pos2 = this.group2.getBBox();

        this.deltaX = pos2.x - pos1.x;
        this.deltaY = pos2.y - pos1.y;
    }

    setInitialState() {
        gsap.set([this.group1, this.group2], { opacity: 1, x: 0, y: 0, transformOrigin: "center center" });
    }

    swapPositions() {
        const atOrigin = (gsap.getProperty(this.group1, 'x') || 0) === 0;

        gsap.set(this.group1, { x: atOrigin ? this.deltaX : 0, y: atOrigin ? this.deltaY : 0 });
        gsap.set(this.group2, { x: atOrigin ? -this.deltaX : 0, y: atOrigin ? -this.deltaY : 0 });
    }

    animate() {
        const tl = gsap.timeline({ repeat: -1 });

        this.createBlinkCycle(tl, this.group1, this.group2);
        this.createBlinkCycle(tl, this.group2, this.group1);
    }

    createBlinkCycle(tl, hideGroup, showGroup) {
        tl.to(hideGroup, { opacity: 1, duration: this.options.blinkDuration, ease: "power1.out" })
            .to(showGroup, { opacity: 1, duration: this.options.swapDuration, ease: "power1.in" })
            .add(() => this.swapPositions());
    }

    setupClickScroll() {
        const clickable = this.cursor.closest('.cursor-clickable');
        if (clickable) {
            clickable.addEventListener('click', () => this.scrollToNextSection());
        }
    }

    scrollToNextSection() {
        const hero = this.cursor.closest('.block-hero');
        if (!hero) return;

        const nextSection = hero.nextElementSibling;
        if (!nextSection) return;

        scrollTo(nextSection, {
            offset: 0,
            duration: 1.4
        });
    }

    static initAll() {
        document.querySelectorAll('.cursor').forEach(cursor => {
            new cursorsAnimations(cursor);
        });
    }
}
